import PropTypes from "prop-types";
import React, { createContext, useContext, useMemo, useState } from "react";

// Create context
const DashboardContext = createContext();

// Provider
export const DashboardProvider = ({ children }) => {
  const [showDashboard, setShowDashboard] = useState(true);
  const contextValue = useMemo(
    () => ({ showDashboard, setShowDashboard }),
    [showDashboard, setShowDashboard]
  );
  return (
    <DashboardContext.Provider value={contextValue}>
      {children}
    </DashboardContext.Provider>
  );
};
DashboardProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
// Hook to use context
export const useDashboard = () => useContext(DashboardContext);
